import { render, staticRenderFns } from "./setTagDialog.vue?vue&type=template&id=5d4c3185&"
import script from "./setTagDialog.vue?vue&type=script&lang=js&"
export * from "./setTagDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports